import { Outlet } from "react-router-dom";

const Business = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Business;
